export const READABILITY_CHUNK_SIZE = 1024;
export const READABILITY_ROW_BOTTOM_PADDING = 8;
